<template>
  <section class="flex">

      <header class="container-1">
          <h3 class="abhyaas">OUR PROGRAMS <span> >  </span>  Bean Yoga</h3>
          <div class="beanyoga">
<h1>Bean Yoga</h1>
          
          <img src="../../assets/beanyoga.png" alt="">
          </div>
          
      
      <img src="../../assets/underline.png" alt="">
      <h3>What they’ll learn </h3>

      <h4>Using music and movement, animal pictures and poses, we help <br> young, growing kids build hand-eye coordination and motor <br> skills. Keeping their physical and mental developmental <br> milestones in mind, we guide the little ones so they gain better <br> body awareness. This aids in increasing their lung capacity as <br> well as encouraging a release of pent up energy. At this stage we <br> are introducing them to the basics of yoga postures and <br> philosophy; through play, stories and poses; in this way we help <br> them to easily connect to themselves and the teachings better. <br> We take care that we tailor our classes to support and strengthen <br> their growing anatomies. And most importantly, our teachers <br> always embody the yogic way of life to lead the impressionable <br> students by example.</h4>
  
      </header>
      <div class="container-2">
      <!-- <img src="../../assets/about_program.png" alt=""> -->
      <div class="card">

          <div class="card_header">
              <h4 class="ten">10% off for all Li’l yogis</h4>
           <div> <h5 class="starting">Starting at </h5>
              <br>
              <h2>$ 120 / Week</h2>
              </div>  
              <div class="buttons">
              <button @click="modalbg= !modalbg">Book Now</button>
              <button @click="modalbg= !modalbg" class="button2">Free Trial</button>
              </div>
          </div>

          <div class="card_body">
              <div class="flex1">
              <img class="eclipse" src="../../assets/beanyoga_eclipse.png" alt="">
              <div>
              <h3 class="year_old" >5 to 12 year old</h3>
              
              <h5 class="divided">Divided in 3 age groups</h5>
              </div>
              </div>
<div class="line"></div>


              <div class="flex1">
              <img class="eclipse" src="../../assets/beanyoga_eclipse.png" alt="">
              <div>
              <h3 class="year_old" >5 to 12 year old</h3>
              
              <h5 class="divided">Divided in 3 age groups</h5>
              </div>
              </div>
<div class="line"></div>


              <div class="flex1">
              <img class="eclipse" src="../../assets/beanyoga_eclipse.png" alt="">
              <div>
              <h3 class="year_old"> 5 to 12 year old</h3>
             
              <h5 class="divided">Divided in 3 age groups</h5>
              </div>
              </div>
              <div class="line"></div>

          </div>



      </div>
      </div>


      <transition name="modal" mode="out-in">
<Register v-if="modalbg" class="registernow" :modalbg="modalbg" @close="modalbg= !modalbg"    />
</transition>
  </section>

</template>

<script>

import Register from "./Register.vue"

export default {
components:{Register},
data(){
    return{
        modalbg:false
    }
},
}
</script>

<style scoped>
.registernow{
    position: fixed;
    left: 0;
    top: 0;
     width: 100%;
    height: 70%;
     display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    
}
.modal-enter-from{
    opacity: 0;
    transform: scale(0);
}
.modal-enter-to{
    opacity: 1;
    transform: scale(1);
}

.modal-enter-active {
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  
}
.modal-leave-from{
    opacity: 1;
    transform: scale(1);
    /* transform: translateY(400px); */
}
.modal-leave-to{
    opacity: 0;
    transform: scale(0);
}
.modal-leave-active {
  transition: all 0.3s ease;
}
.line{
        /* height: 0.1px; */
        border: 1px solid #994DAF;
    /* color: white; */
    background-color: white;
    width: 366px;
    padding-right: 0px;
}
.button2{
    background-color: #791E94;
    border: 2px solid #FF8100;
}
.button2:hover{
    background-color: #FF8100;
}
.year_old{
    color: white;
    font-weight: 500;
}
.divided{
    color: white;
        font-weight: 300;
}

h2{
    color: white;
}
.starting{
    font-weight: 400;
    color: #FFFFFF;
}
.ten{
    font-weight: 600;
    color: #F0A202;
}
.buttons{
              display: flex;
    flex-direction: column;
    /* width: 443px; */
    justify-content: space-between;
    align-items: center;
    height: 115px;
}
.card_header{
        display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    height: 297px;
}
.card_body{
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    height: 234px;
    align-items: center;
    /* padding-right: 103px; */
}
.flex1{
            display: flex;
    align-items: center;
    justify-content: space-between;
    width: 237px;
    margin-right: 103px;
}
.card{
    height: 572px;
    width: 450px;border-radius: 20px;
    background-color: #791E94;
        display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.eclipse{
    height: 50px;
    width: 50px;
}
span{
    color: #FF8100;
}
.beanyoga{
        display: flex;
    align-items: center;
    justify-content: space-between;
    width: 304px;
}
 .abhyaas{
color: #791E94;
    font-weight: 450;
 }  
h3{
    color: #44526B;
}
button{
    color: white;
    background-color: #FF8100;
    border: none;
    padding: 15px 140px;
    border-radius: 10px;
    cursor: pointer;
    transition: 0.3s ease-in;
}
button:hover{
    background-color: #ca6500;
}

h1{
    color: #791E94;
    
    font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
}
h4{
    color: #44526B;
    font-weight: 500;
    line-height: 29px;
}
.flex{
    display: flex;
    justify-content: space-evenly;
    padding-top: 12rem;
    height: 764px;
    width: 90%;
    margin: auto;
}
.container-1{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;
}
body{
    background: #FFFFF2;
}

@media (max-width: 1200px){
    .flex{
flex-wrap: wrap;
height: 1706px;
    }
    .container-1{
height: 583px;
    }
    /* .card{
        width: 450px
    } */
}
@media (max-width: 600px){
    .container-1{
height: 983px;
    }
    .card{
        width: 370px
    }
}


</style>>

